export default __webpack_public_path__ + "static/media/exa.95a0997b.svg";